/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Demo_EyebrowInputs */

const en_funnel_demo_eyebrow = /** @type {(inputs: Funnel_Demo_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hear a real paper, press play`)
};

const es_funnel_demo_eyebrow = /** @type {(inputs: Funnel_Demo_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escucha un artículo real, dale a reproducir`)
};

/**
* | output |
* | --- |
* | "Hear a real paper, press play" |
*
* @param {Funnel_Demo_EyebrowInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_demo_eyebrow = /** @type {((inputs?: Funnel_Demo_EyebrowInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Demo_EyebrowInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_demo_eyebrow(inputs)
	return en_funnel_demo_eyebrow(inputs)
});